// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__LXHi9","label":"style_label__29dVW","labelItem":"style_labelItem__2Otr8","noLinks":"style_noLinks__1pJ9H","noLinksItem":"style_noLinksItem__DCpGp"};